"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconBack = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M19.494 11.5H5.644l6.215-6.66a.499.499 0 1 0-.73-.682l-7 7.5c-.009.01-.008.023-.016.032a.5.5 0 0 0-.096.192q-.007.028-.012.057a.5.5 0 0 0 .028.247q.001.005.002.012c.005.012.018.017.023.03.021.038.04.078.071.112l7 7.5a.5.5 0 0 0 .706.024.5.5 0 0 0 .024-.706L5.644 12.5h13.85a.5.5 0 0 0 0-1" })] })));
};
exports.IconBack = IconBack;
exports.IconBack.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconBack;
